import { intakeChangeRequestApi, intakeChangeRequestKeys } from '@client/api/waterlily';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useIntakeChangeRequest(clientId: string) {
  const queryClient = useQueryClient();
  const state = useQuery({
    queryKey: intakeChangeRequestKeys.detail(clientId),
    queryFn: () => intakeChangeRequestApi.getState(clientId),
    enabled: !!clientId,
  });
  const approval = useMutation({
    mutationFn: async ({
      requestId,
      values,
    }: {
      requestId: string;
      values: Record<string, string | number | boolean | null>;
    }) => {
      if (Object.keys(values).length > 0) {
        await intakeChangeRequestApi.update(clientId, requestId, values);
      }
      return intakeChangeRequestApi.approve(clientId, requestId);
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: intakeChangeRequestKeys.detail(clientId) }),
  });
  const rejection = useMutation({
    mutationFn: ({ requestId, reason }: { requestId: string; reason: string }) =>
      intakeChangeRequestApi.reject(clientId, requestId, reason),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: intakeChangeRequestKeys.detail(clientId) }),
  });
  return {
    ...state,
    approve: approval.mutateAsync,
    approvalError: approval.error,
    isApproving: approval.isPending,
    reject: rejection.mutateAsync,
    rejectionError: rejection.error,
    isRejecting: rejection.isPending,
  };
}
